/**
 * List of all the Error codes which are there in SDS and used in our codebase
 */
export enum ErrorCodes {
    CollectionIdNotFound = 'CollectionIdNotFound',
}
